import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a22406e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "nge-edtext-suggestion-head" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "nge-edtext-actions"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 3,
  class: "nge-edtext-note"
}
const _hoisted_9 = {
  key: 4,
  class: "nge-edtext-admin"
}
const _hoisted_10 = {
  key: 0,
  class: "nge-edtext-note"
}
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["rows"]
const _hoisted_13 = { class: "nge-edtext-hint" }
const _hoisted_14 = {
  key: 0,
  class: "nge-edtext-error"
}
const _hoisted_15 = { class: "nge-edtext-actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "nge-edtext",
    onClick: $setup.onClick
  }, [
    (!$setup.editing)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($setup.isList)
            ? (_openBlock(), _createElementBlock("ol", {
                key: 0,
                class: _normalizeClass($props.listClass)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (s, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    innerHTML: s
                  }, null, 8 /* PROPS */, _hoisted_1))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass($props.textClass),
                innerHTML: $setup.paragraph
              }, null, 10 /* CLASS, PROPS */, _hoisted_2)),
          _createCommentVNode(" A suggestion waiting: the approver sees it and decides; other admins see that it waits "),
          ($setup.suggestion && $setup.backend.showAdminUi)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "nge-edtext-suggestion",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_3, "Suggested" + _toDisplayString($setup.suggestion.by ? ` by ${$setup.suggestion.by}` : '') + _toDisplayString($setup.approver ? '' : ': waiting for approval'), 1 /* TEXT */),
                ($setup.approver && $setup.isList)
                  ? (_openBlock(), _createElementBlock("ol", {
                      key: 0,
                      class: _normalizeClass($props.listClass)
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.suggestionSteps, (s, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          innerHTML: s
                        }, null, 8 /* PROPS */, _hoisted_4))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true),
                ($setup.approver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-edtext-btn nge-edtext-btn--save",
                        disabled: $setup.busy,
                        onClick: $setup.approve
                      }, "Approve", 8 /* PROPS */, _hoisted_6),
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-edtext-btn",
                        disabled: $setup.busy,
                        onClick: $setup.turnDown
                      }, "Turn down", 8 /* PROPS */, _hoisted_7)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.sentNote && $setup.backend.showAdminUi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.sentNote), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.backend.showAdminUi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                ($setup.savedNote)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($setup.savedNote), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "nge-edtext-btn",
                  title: $props.approval && !$setup.approver ? 'Suggest a change: it shows once it is approved. Admins only.' : 'Change this text for everyone. Admins only.',
                  onClick: _withModifiers($setup.startEdit, ["stop"])
                }, _toDisplayString($props.approval && !$setup.approver ? 'Suggest an edit' : 'Edit'), 9 /* TEXT, PROPS */, _hoisted_11)
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "nge-edtext-form",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.draft) = $event)),
            class: "nge-edtext-area",
            rows: $setup.isList ? 10 : 5,
            spellcheck: "true",
            maxlength: "20000"
          }, null, 8 /* PROPS */, _hoisted_12), [
            [_vModelText, $setup.draft]
          ]),
          _createElementVNode("div", _hoisted_13, [
            ($setup.isList)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("Each step on its own line. ")
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createTextVNode("**bold** and [link words](https://...). "),
            ($props.textKey.startsWith('quest.'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" [words](#examples) opens the example cells.")
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "nge-edtext-btn nge-edtext-btn--save",
              disabled: $setup.busy || !$setup.draft.trim(),
              onClick: $setup.save
            }, _toDisplayString($setup.busy ? 'Saving…' : $props.approval && !$setup.approver ? 'Send for approval' : 'Save for everyone'), 9 /* TEXT, PROPS */, _hoisted_16),
            _createElementVNode("button", {
              type: "button",
              class: "nge-edtext-btn",
              disabled: $setup.busy,
              onClick: _cache[2] || (_cache[2] = $event => ($setup.editing = false))
            }, "Cancel", 8 /* PROPS */, _hoisted_17),
            ($setup.saved && (!$props.approval || $setup.approver))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "nge-edtext-btn nge-edtext-btn--quiet",
                  disabled: $setup.busy,
                  title: "Remove the saved text and show the original",
                  onClick: $setup.restore
                }, "Restore original", 8 /* PROPS */, _hoisted_18))
              : _createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}